export default __webpack_public_path__ + "static/media/noStatistics.00b9eb84.svg";